import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ApprovalDataErrorMessage } from '../sidebar/ApprovalDataErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const LazyApprovalProcessBuilder = Loadable({
  loader: () => import( /* webpackChunkName: "ApprovalProcessBuilder" */'./ApprovalProcessBuilder').then(m => ({
    default: m.ApprovalProcessBuilder
  })),
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingSpinner, {
    layout: "centered",
    size: "small"
  }),
  ErrorComponent: ApprovalDataErrorMessage
});